import React from 'react';
import "./CoverMobile.css";
import SearchBarMobile from '../SearchBarMobile/SearchBarMobile';

export default function CoverMobile() {
  return (
    <div className='cover-mb'>
        <div className="content">
            <p>Bienvenido/a</p>
            <h3>Hernan Montilla</h3>
            <SearchBarMobile />
        </div>
    </div>
  )
}
